import React from "react"
import { QueryStatus } from "@reduxjs/toolkit/query"
import { useTranslation } from "react-i18next"
import { getHolidaysQueryFromContext } from "../context-options/utils"
import { useGetHolidaysQuery } from "../holidays/api"
import { HolidayViewModel } from "../holidays/api/holiday"
import { AppMainContextType } from "../types/app-context"

export const useContextHolidays = (mainContext: AppMainContextType | null): UseContextHolidaysResult => {
  const translations = useTranslations()
  const holidaysQuery = getHolidaysQueryFromContext(mainContext)
  const {
    data: holidays = [],
    isLoading,
    isError,
    status,
  } = useGetHolidaysQuery(holidaysQuery, { refetchOnMountOrArgChange: true, skip: !mainContext })

  const queryErrors = React.useMemo(() => {
    const errors: ContextHolidaysQueryErrors = {}
    if (isError) errors.holidays = translations.fetchErrorHolidays
    return errors
  }, [isError, translations.fetchErrorHolidays])

  return {
    holidays,
    queryErrors,
    isLoading,
    isError,
    status,
  }
}

const useTranslations = (defaults = defaultTranslations) => {
  const { t } = useTranslation("translation")

  return {
    fetchErrorHolidays: t("fetchErrorHolidays", defaults.fetchErrorHolidays),
  }
}

const defaultTranslations = {
  fetchErrorHolidays: "Failed to fetch holidays",
}

type ContextHolidaysQueryErrors = {
  holidays?: string
}

type UseContextHolidaysResult = {
  holidays: HolidayViewModel[]
  queryErrors: ContextHolidaysQueryErrors
  isLoading: boolean
  isError: boolean
  status: QueryStatus
}
